import PropTypes from 'prop-types';
import React from 'react';

import { StyledFilterTags } from './filterTags.style';

const FilterTags = ({
  tags,
  inverted = false,
  border = false,
  alignRight = false,
  className,
  onClickTag,
  selected = [],
  allTag,
  allSelected = false,
  onAllClickTag,
  ...props
}) => (
  <StyledFilterTags
    {...props}
    className={className}
    inverted={inverted}
    border={border}
    alignRight={alignRight}
  >
    {allTag && (
      <button
        className={`filterTags__tag ${className ? `${className}__item` : ''} ${
          allSelected || selected?.includes(allTag.id) ? 'filterTags__tag--selected' : ''
        }`}
        key={allTag.id}
        onClick={() =>
          onAllClickTag && onAllClickTag(allTag, allSelected || selected?.includes(allTag.id))
        }
        type="button"
      >
        <p>{allTag.title}</p>
      </button>
    )}

    {tags &&
      tags.map(tag => (
        <button
          className={`filterTags__tag ${className ? `${className}__item` : ''} ${
            allSelected || selected?.includes(tag.id) ? 'filterTags__tag--selected' : ''
          }`}
          key={tag.id}
          onClick={() => onClickTag(tag)}
          type="button"
        >
          <p>{tag.title}</p>
        </button>
      ))}
  </StyledFilterTags>
);

FilterTags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      slug: PropTypes.string,
      status: PropTypes.string
    })
  ),
  selected: PropTypes.arrayOf(PropTypes.string),
  allTag: PropTypes.string,
  allSelected: PropTypes.bool,
  onAllClickTag: PropTypes.func,
  className: PropTypes.string,
  inverted: PropTypes.bool,
  border: PropTypes.bool,
  alignRight: PropTypes.bool,
  onClickTag: PropTypes.func
};

export default FilterTags;
